"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var icon_picker_service_1 = require("../icon-picker.service");
var Subject_1 = require("rxjs/Subject");
var IconPickerPopupComponent = /** @class */ (function () {
    function IconPickerPopupComponent(dialogRef, iconData, iconPickerService) {
        this.dialogRef = dialogRef;
        this.iconData = iconData;
        this.iconPickerService = iconPickerService;
        this.svgIds = [];
        this.destroy$ = new Subject_1.Subject();
        this.icon = iconData.iconId;
    }
    IconPickerPopupComponent.getDialogConfig = function (iconData) {
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.width = '400px';
        dialogConfig.height = 'auto';
        dialogConfig.data = iconData;
        return dialogConfig;
    };
    IconPickerPopupComponent.prototype.ngOnInit = function () {
        this.initIcons();
    };
    IconPickerPopupComponent.prototype.initIcons = function () {
        var _this = this;
        this.iconPickerService.getIcons().takeUntil(this.destroy$).subscribe(function (response) {
            response.forEach(function (iconData) {
                iconData.httpCall.subscribe(function (xmlData) {
                    var parser = new DOMParser();
                    var xmlDoc = parser.parseFromString(xmlData, 'text/xml');
                    var symbols = xmlDoc.getElementsByTagName('symbol');
                    for (var i = 0; i < symbols.length; i++) {
                        _this.svgIds.push(iconData.url + "#" + symbols[i].getAttribute('id'));
                    }
                    _this.defaultIcon = _this.svgIds[0];
                });
            });
        });
    };
    IconPickerPopupComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    IconPickerPopupComponent.prototype.save = function () {
        this.dialogRef.close(this.icon ? this.icon : this.defaultIcon);
    };
    IconPickerPopupComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    IconPickerPopupComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-icon-picker-popup',
            template: require('./icon-picker-popup.component.html'),
            styles: [require('./icon-picker-popup.component.css')],
        }),
        __param(1, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [material_1.MatDialogRef, Object, icon_picker_service_1.IconPickerService])
    ], IconPickerPopupComponent);
    return IconPickerPopupComponent;
}());
exports.IconPickerPopupComponent = IconPickerPopupComponent;
//# sourceMappingURL=icon-picker-popup.component.js.map